import React, { Fragment, Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import { object, bool, node, func, number } from 'prop-types';

import { Marker, Polyline } from 'google-maps-react';

class MapOrders extends Component {
  static propTypes = {
    configured: bool,
    google: object,
    selected: bool,
    map: object,
    order: object,
    preventRenderDestination: bool,
    preventRenderOrigin: bool,
    virtualDestination: bool,
    handleClick: func,
    handleMouseover: func,
    handleMouseout: func,
    orderId: number,
    tooltipContent: node,
  };

  infowindow = null;
  midCoordinate = null;

  componentDidMount = () => {
    const { google, order, virtualDestination } = this.props;
    const content = this.renderTooltipContent();

    this.infowindow = new google.maps.InfoWindow({
      content: content,
    });

    setTimeout(() => {
      this.midCoordinate = new google.maps.geometry.spherical.interpolate(
        new google.maps.LatLng(order.origin),
        new google.maps.LatLng(order.destination),
        0.5
      );
      
      const position = virtualDestination
        ?
          order.origin
        :
          {
            lat: this.midCoordinate.lat(),
            lng: this.midCoordinate.lng(),
          }
      ;
  
      this.infowindow.setPosition(position);
    }, 1000);
  }

  componentDidUpdate = () => {
    const { map, selected } = this.props;

    selected
      ?
        this.infowindow.open(map)
      :
        this.infowindow.close()
    ;
  }

  renderTooltipContent() {
    const { tooltipContent } = this.props;

    return ReactDOMServer.renderToString(
      <div className={'tooltip white'}>
        <div className={'innerBlock'}>
          {typeof tooltipContent === 'function'
            ? tooltipContent()
            : tooltipContent}
        </div>
      </div>
    );
  }

  render () {
    const {
      preventRenderOrigin,
      preventRenderDestination,
      order,
      configured,
      google,
      virtualDestination,
      handleClick,
      handleMouseover,
      handleMouseout,
      orderId,
      ...rest
    } = this.props;
    
    return (
      <Fragment>
        {!preventRenderOrigin &&
          <Marker
            draggable
            onClick={virtualDestination && handleClick}
            orderId={virtualDestination && orderId}
            position={order.origin}
            icon={{
              url: virtualDestination
                ? '/assets/marker-blue.svg'
                : '/assets/marker-red.svg',
              anchor: new google.maps.Point(7,8),
              scaledSize: new google.maps.Size(14,14)
            }}
            google={google}
            {...rest}
          />
        }
        {!virtualDestination && configured
          ? <Polyline
              onClick={handleClick}
              onMouseover={handleMouseover}
              onMouseout={handleMouseout}
              orderId={!virtualDestination && orderId}
              path={[order.origin, order.destination]}
              strokeColor='#e40000'
              strokeOpacity={0.8}
              strokeWeight={2}
              geodesic
              google={google}
              {...rest}
            />
          : null
        }
        {!preventRenderDestination && !virtualDestination
          ? <Marker
              position={order.destination}
              icon={{
                url: '/assets/marker-red.svg',
                anchor: new google.maps.Point(7,8),
                scaledSize: new google.maps.Size(14,14)
              }}
              google={google}
              {...rest}
            />
          : null
        }
      </Fragment>
    );
  }
}

export default MapOrders;



// WEBPACK FOOTER //
// ./src/uis/components/Map/MapOrders/MapOrders.js